import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, path = '' }) => {
  const siteName = 'Sun Kamal Academy';
  const fullTitle = title ? `${title} | ${siteName}` : `${siteName} | Culture & Arts Academy`;
  const defaultDesc = 'Learn Chess, Tabla, Yoga & more from expert instructors. Online live classes with certificates. Culture & Arts Academy.';

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description || defaultDesc} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description || defaultDesc} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description || defaultDesc} />
      {path && <link rel="canonical" href={`https://sunkamalsports.online${path}`} />}
    </Helmet>
  );
};

export default SEO;
